(function (window, $) {
  var Cls = {};

  Cls.$slider = null;

  var firstFlag = false;
  var $title1 = null;
  var $title2 = null;
  var $catWrap = null;
  var temp = 0;
  var numArray = [10, 3000, 20000, 150000, 300000, 9999999];

  /**
   *
   */
  Cls.init = function (vars) {
    //
    var options = {
      prev_click_func: null,
      next_click_func: null,
      dot_click_func: null,
    };

    $title1 = $("#seg2 .title1");
    $title2 = $("#seg2 .title2");
    $catWrap = $("#seg2 .catWrap");
    $frame = $("#seg2 .fixedArea4seg2");

    options = $.extend(options, vars);

    Cls.$slider = new Seg2Slider("#seg2", options);

    $frame.hide();
    $catWrap.hide();
  };

  Cls.fixedAreaAnime = function () {
    $frame.fadeIn(1200);
    Anime.vertical($title1, "-=100px", 700, 1200, "easeOutQuint");
    Anime.vertical($title2, "-=100px", 700, 1200, "easeOutQuint");
    $catWrap.css({ left: $(window).width() + "px" }).show();
  };

  Cls.cat0 = function () {
    if (firstFlag !== true) {
      Cls.fixedAreaAnime();
      firstFlag = true;
      Cls.$slider.reset(0);
    } else {
      Cls.$slider.moveAt(0);
    }
  };
  Cls.cat1 = function () {
    Cls.$slider.moveAt(1);
  };
  Cls.cat2 = function () {
    Cls.$slider.moveAt(2);
  };
  Cls.cat3 = function () {
    Cls.$slider.moveAt(3);
  };
  Cls.cat4 = function () {
    Cls.$slider.moveAt(4);
  };
  Cls.cat5 = function () {
    if (firstFlag !== true) {
      Cls.fixedAreaAnime();
      firstFlag = true;

      Cls.$slider.moveAt(5);
    } else {
      Cls.$slider.moveAt(5);
    }
  };

  Cls.prev = function () {
    Cls.$slider.prev();
  };

  Cls.next = function (func) {
    Cls.$slider.next();
  };

  Cls.moveAt = function (idx) {};

  /*
     -------------------------------------------- */
  /**
   *
   */
  var Seg2Slider = function (id, vars) {
    var idx = 0;

    var $container = $(id);
    var $titles = null;
    var $items = null;
    var $slider = null;
    var $dots = null;
    var $btn_prev = null;
    var $btn_next = null;

    var counters = null;

    var b_move = false;
    var offset_x = 0;

    var options = {
      fade_opacity: 0.3,
      move_delay: 1200,
      fade_delay: 500,
      box_diff: 200,
      move_easing: "easeInOutQuart",
      show_easing: "easeInOutCubic",
      prev_click_func: null,
      next_click_func: null,
      dot_click_func: null,
    };

    options = $.extend(options, vars);

    var move_delay_rate = {
      prev: [1.0, 1.0, 1.0, 1.0, 1.0, 1.0],
      next: [1.0, 1.0, 1.0, 1.0, 1.0, 1.0],
    };

    var show_title_delay = {
      prev: [0, 0, 0, 0, 0, 0],
      next: [0, 0, 0, 0, 0, 0],
    };

    var size_diff_rate = [
      { l: 0.8, r: 1.6 },
      { l: 0.8, r: 1.6 },
      { l: 0.8, r: 1.6 },
      { l: 0.5, r: 2.5 },
      { l: 0.4, r: 1.6 },
      { l: 0.4, r: 1.6 },
    ];

    var counter_options = [
      {
        startVal: 0,
        endVal: 10,
        plusVal: 1,
        speed: 100,
        autostart: false,
      },
      {
        startVal: 0,
        endVal: 3000,
        plusVal: 30,
        speed: 1000,
        autostart: false,
      },
      {
        startVal: 0,
        endVal: 20000,
        plusVal: 251,
        speed: 1200,
        autostart: false,
      },
      {
        startVal: 0,
        endVal: 150000,
        plusVal: 1411,
        speed: 1200,
        autostart: false,
      },
      {
        startVal: 0,
        endVal: 300000,
        plusVal: 3211,
        speed: 1200,
        autostart: false,
      },
    ];

    /* Public Function
         ------------------------------------------ */
    /**
     *
     */
    this.setup = function () {
      $slider = $(".catWrap", $container);
      $titles = $(".catTitle .box", $container);
      $items = $(".catBoxInner", $container);
      $dots = $(".fixedArea4seg2 ul.dots li", $container);
      $btn_prev = $(".fixedArea4seg2 .prev", $container);
      $btn_next = $(".fixedArea4seg2 .next", $container);

      $btn_prev.click(this.prev);
      $btn_next.click(this.next);
      $dots.click(function () {
        var idx = ($(this).attr("class") + "").substr(3, 1);
        moveAt(idx, function () {
          options.dot_click_func(idx);
        });
      });

      var box_w = 0;
      for (var i = 0, max = $items.length; i < max; i++) {
        box_w = $items.eq(i).width();
        $items.eq(i).data("data-width", box_w);
      }

      $titles.css({ top: "-100px", opacity: 0 });
      $(".row3", $titles).css({ top: "-=10px", opacity: 0 });

      counters = [];
      $(".fixedArea4seg2 .row2 .num.js-count", $container).each(function (idx) {
        counters.push($(this));
      });

      this.reset();
    };

    /*
     *
     */
    this.reset = function () {
      idx = -1;
      moveAt(0);
    };

    this.prev = function () {
      moveAt(idx - 1, options.prev_click_func);
    };

    this.next = function () {
      moveAt(idx + 1, options.next_click_func);
    };

    this.moveAt = function (idx) {
      moveAt(idx);
    };

    var moveAt = function (move_idx, func) {
      if (b_move) return false;

      b_move = true;

      if (move_idx != idx && move_idx >= 0 && move_idx < $items.length) {
        $dots.removeClass("active");
        $dots.eq(move_idx).addClass("active");

        if (move_idx == 0) $btn_prev.fadeOut(options.fade_delay);
        else $btn_prev.fadeIn(options.fade_delay);

        if (move_idx == $items.length - 1)
          $btn_next.fadeOut(options.fade_delay);
        else $btn_next.fadeIn(options.fade_delay);

        var move_type = move_idx > idx ? "next" : "prev";

        if (firstFlag !== false) {
          swapTitle(idx, move_idx, move_type, numArray[move_idx]);
        }

        var pos_x = 0;
        var box_w = 0;
        var total_w = 0;
        var rate = 0;

        $slider.width(10200);
        for (var i = 0, max = $items.length; i < max; i++) {
          box_w = Number($items.eq(i).data("data-width"));

          if (i < move_idx) {
            rate = Math.pow(size_diff_rate[move_idx].l, move_idx - i);
            box_w = Math.floor(box_w * rate);
            if (box_w > 1500) box_w = 1500;
            $items
              .eq(i)
              .stop()
              .animate(
                { width: box_w + "px", opacity: options.fade_opacity },
                options.move_delay * move_delay_rate[move_type][move_idx],
                options.move_easing
              );

            pos_x += box_w + options.box_diff;
          } else if (i > move_idx) {
            rate = size_diff_rate[move_idx].r * (i - move_idx);
            box_w = Math.floor(box_w * rate);
            if (box_w > 1500) box_w = 1500;
            $items
              .eq(i)
              .stop()
              .animate(
                { width: box_w + "px", opacity: options.fade_opacity },
                options.move_delay * move_delay_rate[move_type][move_idx],
                options.move_easing
              );
          } else {
            $items
              .eq(i)
              .stop()
              .animate(
                { width: box_w + "px", opacity: 1.0 },
                options.move_delay * move_delay_rate[move_type][move_idx],
                options.move_easing
              );
          }
          total_w += box_w + options.box_diff;
        }

        var offset_x = $(window).outerWidth() / 2;
        pos_x += Number($items.eq(move_idx).data("data-width")) / 2;

        $slider
          .stop()
          .animate(
            { left: offset_x - pos_x + "px" },
            options.move_delay * move_delay_rate[move_type][move_idx],
            options.move_easing,
            function () {
              idx = move_idx;
              b_move = false;

              if (func && typeof func == "function") {
                func();
              }
            }
          );
      } else {
        b_move = false;

        if (func && typeof func == "function") {
          func();
        }
      }
    };

    var swapTitle = function (current_idx, next_idx, move_type, num) {
      var interval = 800;
      var delay = 200;
      var point_interval = 500;

      $(".row3", $titles.eq(current_idx))
        .stop()
        .delay(2000)
        .animate(
          { top: "78px", opacity: 0 },
          point_interval,
          options.show_easing
        );

      $titles
        .eq(current_idx)
        .stop()
        .animate({ opacity: 0 }, interval, options.show_easing, function () {
          $titles.eq(current_idx).stop().css({ top: "-100px" });

          if (next_idx != $items.length - 1) {
            $(".row3", $titles.eq(next_idx))
              .delay(1500)
              .animate(
                { top: "85px", opacity: 1 },
                point_interval,
                options.show_easing
              );
            Cls.startCountUp();

            $titles
              .eq(next_idx)
              .stop()
              .delay(show_title_delay[move_type][next_idx])
              .animate(
                { top: "0px", opacity: 1 },
                interval,
                options.show_easing
              );
          } else {
            $(".row4", $titles.eq(next_idx)).css({ opacity: 0 });
            $(".row2", $titles.eq(next_idx)).css({ opacity: 1 });

            Cls.startCountUp();
            $titles
              .eq(next_idx)
              .stop()
              .delay(show_title_delay[move_type][next_idx])
              .animate(
                { top: "0px", opacity: 1 },
                interval,
                options.show_easing,
                function () {
                  $(".row2", $titles.eq(next_idx))
                    .stop()
                    .delay(1500)
                    .animate(
                      { opacity: 0 },
                      point_interval + 1000,
                      options.show_easing
                    );
                  $(".row3", $titles.eq(next_idx))
                    .delay(2600)
                    .animate(
                      { top: "88px", opacity: 1 },
                      point_interval,
                      options.show_easing
                    );
                  $(".row4", $titles.eq(next_idx))
                    .delay(1700)
                    .animate(
                      { opacity: 1 },
                      point_interval + 1000,
                      options.show_easing
                    );
                }
              );
          }
        });

      /*ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー

            ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー*/
      Cls.startCountUp = function () {
        var plusNum;
        var addNum;
        var speedNum = 1;

        if (temp == 0 || temp == num) {
          speedNum = 500;
          temp = 0;
        }

        if (temp - num > 0) {
          addNum = Math.round((temp - num) / 230) + 1;
          plusNum = -1 * addNum;
        } else if (temp - num < 0) {
          addNum = Math.round((num - temp) / 230) + 1;
          plusNum = addNum;
        }

        if (next_idx == 5) {
          temp = 300000;
          speedNum = 1;
          plusNum = 14231;
        }

        counters[next_idx].countUpAnimate({
          startVal: temp,
          endVal: num,
          plusVal: plusNum,
          speed: speedNum,
        });
        temp = num;
      };
    };

    this.setup();

    return this;
  };

  /***
   *
   **/
  var countUpAnimate = function (target, options) {
    var opt = {
      startVal: 0,
      endVal: 100,
      plusVal: 1,
      speed: 1000,
      autostart: true,
    };
    var callback = null;

    $.extend(opt, options);

    var $el = $(target);
    var nowVal = opt.startVal;
    var intervalSpeed = opt.speed / (opt.endVal - opt.startVal) / opt.plusVal;

    $el.append('<span class="dummy" />');

    var dummyVal =
      opt.endVal.toString().length > opt.startVal.toString().length
        ? opt.endVal
        : opt.startVal;
    var elWidth = $el.find(".dummy").text(addComma(dummyVal)).width();

    $el.find(".dummy").remove();

    $el
      .css({
        textAlign: "right",
      })
      .text(nowVal);

    function addComma(n) {
      var num = n.toString().replace(/,/g, "");
      while (num != (num = num.replace(/^(-?\d+)(\d{3})/, "$1,$2")));
      return num;
    }

    function countUp() {
      nowVal += opt.plusVal;
      $el.text(addComma(nowVal));

      if (nowVal < opt.endVal) {
        setTimeout(function () {
          countUp();
        }, intervalSpeed);
      } else {
        $el.text(addComma(opt.endVal));
        if (callback && typeof callback == "function") {
          callback();
        }
      }
    }

    this.restart = function (func) {
      nowVal = opt.startVal;
      callback = func;

      setTimeout(function () {
        countUp();
      }, intervalSpeed);
    };

    if (opt.autostart) {
      setTimeout(function () {
        countUp();
      }, intervalSpeed);
    }

    return this;
  };

  window.Seg2 = Cls;
})(window, $brand);
